import { render, staticRenderFns } from "./ReleaseForumSucc.vue?vue&type=template&id=dde00f9e&scoped=true"
import script from "./ReleaseForumSucc.vue?vue&type=script&lang=js"
export * from "./ReleaseForumSucc.vue?vue&type=script&lang=js"
import style0 from "./ReleaseForumSucc.vue?vue&type=style&index=0&id=dde00f9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dde00f9e",
  null
  
)

export default component.exports